export const getClareData = () => ({
  name: "Clare",
  country: "Australie",
  region: "Clare Valley",
  description: "Clare est le cœur de la Clare Valley, réputé pour ses Riesling de classe mondiale et ses Shiraz puissants. Son climat continental et ses sols calcaires créent des conditions idéales pour des vins de grande finesse.",
  type: "subregion",
  mapAreas: [
    { region: "Clare", x: 42, y: 72, color: "#d4a4d4", size: 4 }
  ],
  statistics: {
    totalArea: "2,500 ha",
    production: "0.18 million hectolitres",
    altitude: "400-500m",
    appellations: "Clare GI",
    exportPercentage: "35%"
  },
  characteristics: {
    climate: "Climat continental avec étés chauds et secs, hivers froids, grandes amplitudes thermiques",
    soil: "Sols calcaires, argileux, excellente rétention d'eau",
    viticulture: "Viticulture traditionnelle, vieilles vignes, rendements limités"
  },
  wineStyles: {
    red: "Shiraz puissants et structurés, Cabernet Sauvignon élégants, assemblages complexes",
    white: "Riesling de classe mondiale, Chardonnay aromatiques, Sauvignon Blanc frais",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "Clare est le berceau de la viticulture dans la Clare Valley, avec les premiers vignobles plantés dans les années 1840. La sous-région s'est imposée comme l'une des plus prestigieuses d'Australie pour les Riesling.",
  foodPairing: "Cuisine australienne : fruits de mer, poissons, viandes rouges, fromages affinés, cuisine fusion.",
  grapeVarieties: {
    white: ["Riesling", "Chardonnay", "Sauvignon Blanc"],
    red: ["Shiraz", "Cabernet Sauvignon", "Merlot"]
  },
  keyProducers: ["Jim Barry", "Kilikanoon", "Grosset"],
  notableWines: {
    "riesling": "Riesling de classe mondiale, vieillissement exceptionnel",
    "shiraz": "Shiraz puissants et structurés",
    "chardonnay": "Chardonnay aromatiques et complexes"
  }
}); 